





































































































































































import Vue from "vue";
import { Task, TaskGroup } from "@/tasks";
import TasksList from "../tasks/TasksList.vue";
import { TaskFilterOption, TaskSortOption } from "../../enums";
import { filter } from "vue/types/umd";
import Utils from "@/utils";
import TaskFilter from "../tasks/TasksFilter.vue";
import storeHelper from "../../store/store-helper";
import Notifications from "@/store/modules/notifications/notifications";

export default Vue.extend({
    name: "NotificationsTab",
    components: { TasksList, TaskFilter },
    props: {
        value: Array as () => Task[],
        team: Boolean,
        isBusy: Boolean
    },
    data: () => {
        return {
            search: "",
            sort: TaskSortOption.Created,
            notificationFilterDrawer: false,
            filteredNotifications: [] as Task[],
            filter: TaskFilterOption.My,
            taskgroups: [] as TaskGroup[],
            bus: new Vue()
        };
    },
    created() {
        storeHelper.subscriptionsStore.loadMySubscriptionsAsync();
    },
    updated() {
        //Make sure we set on scroll event everytime when updated is called
        this.bus?.$emit("set-on-scroll-event");
    },
    watch: {
        sort() {
            switch (this.sort) {
                case TaskSortOption.Important:
                    this.sortTasksOnImportant();
                    break;
                default:
                    this.sortTaskOnLastModified();
                    break;
            }
        }
    },
    computed: {
        mdAndDownView(): boolean {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        notifications(): Task[] {
            return this.value.filter(x => x.finished == false);
        },
        sortOptions(): string[] {
            const options: Array<string> = [TaskSortOption.Created, TaskSortOption.Important];
            return options;
        },
        selectedFilter(): TaskFilterOption {
            return storeHelper.notificationsStore.selectedFilter;
        },
        hasNotifications(): boolean {
            return this.notifications.length > 0;
        },
        hasFilteredNotifications(): boolean {
            return this.filteredNotifications.length > 0;
        }
    },
    methods: {
        sortTasksOnImportant(): void {
            this.filteredNotifications.sort(
                (a, b) =>
                    (a.is_important && b.is_important
                        ? a.is_important === b.is_important
                            ? a.last_modified_date_time < b.last_modified_date_time
                                ? 1
                                : -1
                            : 0
                        : 0) ||
                    (a.is_important ? -1 : 0) ||
                    (b.is_important ? 1 : 0) ||
                    (a.last_modified_date_time.getTime() === b.last_modified_date_time.getTime()
                        ? 0
                        : a.last_modified_date_time < b.last_modified_date_time
                        ? 1
                        : -1) ||
                    (a.deadline_date_time && b.deadline_date_time
                        ? a.deadline_date_time.getTime() === b.deadline_date_time.getTime()
                            ? 0
                            : a.deadline_date_time < b.deadline_date_time
                            ? 1
                            : -1
                        : 0)
            );
        },
        sortTaskOnLastModified(): void {
            this.filteredNotifications.sort(
                (a, b) =>
                    (a.last_modified_date_time.getTime() === b.last_modified_date_time.getTime()
                        ? 0
                        : a.last_modified_date_time < b.last_modified_date_time
                        ? 1
                        : -1) ||
                    (a.deadline_date_time && b.deadline_date_time
                        ? a.deadline_date_time.getTime() === b.deadline_date_time.getTime()
                            ? 0
                            : a.deadline_date_time < b.deadline_date_time
                            ? 1
                            : -1
                        : 0)
            );
        }
    }
});
